import Reveal from "@/components/Reveal";
import { scrollToSection } from "@/data/catalog";
import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import { Globe } from "lucide-react";

const QUICK_LINKS = [
  ["Home", "#top"],
  ["Services", "#services"],
  ["Platforms", "#pricing"],
  ["FAQ", "#faq"],
  ["Contact", "#contact"],
];

const SERVICE_LINKS = [  ["instagram", "Instagram"],
  ["tiktok", "TikTok"],
  ["youtube", "YouTube"],
  ["spotify", "Spotify"],
  ["facebook", "Facebook"],
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-[#1F1F1F] bg-[#050505] pt-20 pb-10">
      <div className="pointer-events-none absolute -bottom-32 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-[#E11D2E]/[0.06] blur-[140px]" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <Reveal>
            <div className="flex flex-col items-start leading-none" data-testid="footer-logo">
              <span className="font-display text-2xl uppercase tracking-wide text-[#E11D2E]">CyberSmoke</span>
              <span className="font-display text-sm uppercase tracking-[0.42em] text-[#E11D2E]/80">Media</span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#8A8A8A]">
              Cyber Smoke Media is a full-service digital marketing and media promotion company built
              to take your brand to the next level.
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#E11D2E]">Quick links</p>
            <div className="mt-4 flex flex-col gap-3">
              {QUICK_LINKS.map(([label, href]) => (
                <button
                  key={href}
                  data-testid={`footer-nav-${label.toLowerCase()}`}
                  onClick={() => (href === "#top" ? window.__lenis?.scrollTo(0, { duration: 1.2 }) : scrollToSection(href))}
                  className="w-fit text-sm text-[#8A8A8A] transition-colors duration-300 hover:text-white"
                >
                  {label}
                </button>
              ))}
              <Link
                to="/track"
                data-testid="footer-track-link"
                className="w-fit text-sm text-[#8A8A8A] transition-colors duration-300 hover:text-white"
              >
                Track order
              </Link>
              <Link
                to="/admin"
                data-testid="footer-admin-link"
                className="w-fit text-sm text-[#8A8A8A] transition-colors duration-300 hover:text-[#E11D2E]"
              >
                Admin
              </Link>
            </div>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#E11D2E]">Our services</p>
            <div className="mt-4 flex flex-col gap-3">
              {SERVICE_LINKS.map(([slug, label]) => (
                <Link
                  key={slug}
                  to={`/services/${slug}`}
                  data-testid={`footer-service-${slug}`}
                  className="w-fit text-sm text-[#8A8A8A] transition-colors duration-300 hover:text-white"
                >
                  {label}
                </Link>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.24}>
            <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#E11D2E]">Follow us</p>
            <div className="mt-4 flex gap-3">
              <a
                data-testid="footer-instagram-link"
                href="https://instagram.com/cybersmokemedia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="flex h-10 w-10 items-center justify-center border border-[#1F1F1F] text-[#8A8A8A] transition-all duration-300 hover:border-[#E11D2E] hover:text-[#E11D2E]"
              >
                <FaInstagram size={16} />
              </a>
              <a
                data-testid="footer-website-link"
                href="https://cybersmokemedia.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Website"
                className="flex h-10 w-10 items-center justify-center border border-[#1F1F1F] text-[#8A8A8A] transition-all duration-300 hover:border-[#E11D2E] hover:text-[#E11D2E]"
              >
                <Globe size={16} />
              </a>
            </div>
            <p className="mt-4 font-mono text-xs text-[#8A8A8A]">@cybersmokemedia</p>
          </Reveal>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-[#1F1F1F] pt-8">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#555555]">
            © 2026 Cyber Smoke Media. All rights reserved.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#555555]">
            Terms & Conditions&nbsp;&nbsp;|&nbsp;&nbsp;Privacy Policy
          </p>
        </div>
      </div>
    </footer>
  );
}
